import {
    CERTIFICATE_TANANT_LIST_ADMIN_REQUEST,
    CERTIFICATE_TANANT_LIST_ADMIN_SUCCESS,
    CERTIFICATE_TANANT_LIST_ADMIN_FAILURE,
    CERTIFICATE_VERIFICATION_REQUEST,
    CERTIFICATE_VERIFICATION_SUCCESS,
    CERTIFICATE_VERIFICATION_FAILURE,
    CERTIFICATE_THEME_LIST_REQUEST,
    CERTIFICATE_THEME_LIST_SUCCESS,
    CERTIFICATE_THEME_LIST_FAILURE,
    CERTIFICATE_LIST_USER_REQUEST,
    CERTIFICATE_LIST_USER_SUCCESS,
    CERTIFICATE_LIST_USER_FAILURE,
    CERTIFICATE_THEME_CREATE_REQUEST,
    CERTIFICATE_THEME_CREATE_SUCCESS,
    CERTIFICATE_THEME_CREATE_FAILURE,
    CERTIFICATE_THEME_CREATE_RESET, 
    CERTIFICATE_THEME_UPDATE_REQUEST,
    CERTIFICATE_THEME_UPDATE_SUCCESS,
    CERTIFICATE_THEME_UPDATE_FAILURE,
    CERTIFICATE_THEME_UPDATE_RESET,
    CERTIFICATE_THEME_DELETE_REQUEST,
    CERTIFICATE_THEME_DELETE_SUCCESS,
    CERTIFICATE_THEME_DELETE_FAILURE,
} from "../types/certificateTypes";


const initialState = {
    isLoading: false,
    data: [],
    error: null
}

const initialVerificationState = {
    verificationLoading: false,
    verificationData: null,
    verificationError: null
}

const getCertificateListTanantAdmin = (state = initialState, action) => {
    switch (action.type) {
        case CERTIFICATE_TANANT_LIST_ADMIN_REQUEST:
            return {
                ...state,
                isLoading: true,
            };
        case CERTIFICATE_TANANT_LIST_ADMIN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload,
            };
        case CERTIFICATE_TANANT_LIST_ADMIN_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        default:
            return state;
    }
}

const getCertificateThemeList = (state = initialState, action) => {
    switch (action.type) {
        case CERTIFICATE_THEME_LIST_REQUEST:
            return {
                ...state,
                isLoading: true,
            };
        case CERTIFICATE_THEME_LIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload,
            };
        case CERTIFICATE_THEME_LIST_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        default:
            return state;
    }
}

const verifyCertificate = (state = initialVerificationState, action) => {
    switch (action.type) {
        case CERTIFICATE_VERIFICATION_REQUEST:
            return {
                ...state,
                verificationLoading: true,
                verificationError: null,
            };
        case CERTIFICATE_VERIFICATION_SUCCESS:
            return {
                ...state,
                verificationLoading: false,
                verificationData: action.payload,
            };
        case CERTIFICATE_VERIFICATION_FAILURE:
            return {
                ...state,
                verificationLoading: false,
                verificationError: action.payload,
            };
        default:
            return state;
    }
}

const getCertificateListUser = (state = initialState, action) => {
    switch (action.type) {
        case CERTIFICATE_LIST_USER_REQUEST:
            return {
                ...state,
                isLoading: true,
            };
        case CERTIFICATE_LIST_USER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload,
            };
        case CERTIFICATE_LIST_USER_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        default:
            return state;
    }
}

const createCertificateTheme = (state = initialState, action) => {
    switch (action.type) {
        case CERTIFICATE_THEME_CREATE_REQUEST:
            return {
                ...state,
                isLoading: true,
            };
        case CERTIFICATE_THEME_CREATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload,
            };
        case CERTIFICATE_THEME_CREATE_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case CERTIFICATE_THEME_CREATE_RESET:
            return {
                ...state,
                isLoading: false,
                data: null,
                error: null,
            };
        default:
            return state;
    }
}   

const updateCertificateTheme = (state = initialState, action) => {
    switch (action.type) {
        case CERTIFICATE_THEME_UPDATE_REQUEST:
            return {
                ...state,
                isLoading: true,
            };
        case CERTIFICATE_THEME_UPDATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload,
            };
        case CERTIFICATE_THEME_UPDATE_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case CERTIFICATE_THEME_UPDATE_RESET:
            return {
                ...state,
                isLoading: false,
                data: null,
                error: null,
            };
        default:
            return state;
    }
}


const deleteCertificateTheme = (state = initialState, action) => {
    switch (action.type) {
        case CERTIFICATE_THEME_DELETE_REQUEST:
            return {
                ...state,
                isLoading: true,
            };
        case CERTIFICATE_THEME_DELETE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload,
            };
        case CERTIFICATE_THEME_DELETE_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        default:
            return state;
    }
}

export { getCertificateListTanantAdmin, getCertificateThemeList, verifyCertificate, getCertificateListUser, createCertificateTheme, updateCertificateTheme, deleteCertificateTheme };